module.exports = {
  connection: 'Connection',
  message: {
    attemptingReconnect: 'Attempting to reconnect.',
    disconnected: 'Disconnected from the server.',
    lostConnectionAwaitingRetry: 'Lost connection to server. Awaiting retry.'
  }
}



//////////////////
// WEBPACK FOOTER
// ./src/plugins/localisation/languages/pt/connection.js
// module id = MZG2
// module chunks = 1